import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: '[roof-type-8]',
    templateUrl: './roof-type-8.component.html',
    styleUrl: './roof-type-8.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RoofType8Component {
}
